export default "__VITE_ASSET__bliN5qer__"